module.exports = __webpack_public_path__ + "img/dev1.08362923.png";